import { render } from "./Event.vue?vue&type=template&id=c4126dfa&scoped=true"
import script from "./Event.vue?vue&type=script&lang=js"
export * from "./Event.vue?vue&type=script&lang=js"

import "./Event.vue?vue&type=style&index=0&id=c4126dfa&lang=scss&scoped=true"

import exportComponent from "/Users/vonwong/Dropbox/ClaudeCode/MeetingOS/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4126dfa"]])

export default __exports__